
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "BaseSvg",
    props: ["width", "height", "fill", "viewBox", "class"]
  })
